/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import "./style.scss"
import { DSLogo } from '../../../../components/images_module'
import { CCol, CForm, CRow, CSpinner } from '@coreui/react'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import CustomValuesHook from '../../../../Hooks/customValuesHook';
import { checkForNumericEnFaString, isValidEmailStrictly, persianToEnglishChar, setToken, timingFunction,customTrim } from '../../../../components/helper';
import { useSelector } from 'react-redux';
import { checkExistEmail, getCareerField, resetIsExistEmailProps } from '../../../../service/actions/authActions';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CheckBoldSVG, CloseEyeSVG, EyeSVG, RegisterSVG } from '../../../../components/IconSvg';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { postLogin, postRegister } from '../../../../service/reactQueryServices/authService';
import { RegisterPayload } from '../../../../service/types/Auth/authApiRequestType';
import { toast } from 'react-toastify';
import { types } from '../../../../service/types';

const RegisterPage = () => {
    const getIsEmailExistSuccess = useSelector((state: any) => state.authReducer.SuccessExistEmail)
    const getIsEmailExistResult = useSelector((state: any) => state.authReducer.EmailExist)
    const getIsEmailExistPending = useSelector((state: any) => state.authReducer.WaitingExistEmail)
    const careerList = useSelector((state: any) => state.authReducer.Career)

    const [formState, setFormState] = CustomValuesHook({ displayPassword: true })
    const [userInfo, setUserInfo] = CustomValuesHook({
        Gender: undefined, Mobile: "", Email: "", CareerFieldId: "", OtherCareerField: "", Password: "",
        LastName: "",
        FirstName: "",
    })
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const { mutateAsync: register, isLoading: registerPending } = useMutation("register", postRegister);
    const { mutateAsync: login, isLoading: loginPending } = useMutation("login", postLogin);
    const [isTyping, setIsTyping] = useState()


    const validation = Yup.object({
        FirstName: Yup.string().required("وارد کردن نام الزامی است."),
        LastName: Yup.string().required("وارد کردن نام خانوادگی الزامی است."),
        Gender: Yup.string().required("وارد کردن جنسیت الزامی است."),
        Mobile: Yup.string().required("وارد کردن شماره تلفن همراه الزامی است."),
        Email: Yup.string().required("وارد کردن پست الکترونیک الزامی است.")
            .test("isExist", "", function (value) {
                if (value &&formState.email !== value) {
                    setFormState({ email: customTrim(value) })
                    if (isValidEmailStrictly(customTrim(value)) && !getIsEmailExistPending) {

                        timingFunction(setIsTyping, isTyping, function () {
                            dispatch(checkExistEmail({ Email: customTrim(value), username: customTrim(value) }))

                        })


                    }
                }
                return true
            }),
        Password: Yup.string().required("وارد کردن کلمه عبور الزامی است.").min(6, "رمز عبور می‌بایست حداقل شامل 6 کاراکتر باشد."),
        CareerFieldId: Yup.string().required("وارد کردن زمینه فعالیت الزامی است."),


    })

    useEffect(() => {
        dispatch(getCareerField())

    }, [])



    const handleSubmit = (_values: RegisterPayload) => {
        if (!formState.phoneNumberError && getIsEmailExistSuccess && getIsEmailExistResult) {
            if (getIsEmailExistSuccess && !getIsEmailExistResult) {
                return
            }
            setUserInfo({ ..._values,Email:customTrim(_values.Email) })
            // dispatch(registerUser(_values))
            try {
                register({ ..._values,Email:customTrim(_values.Email) }).then(async (response) => {

                    if (response.Status === 1) {
                        toast.success(response.Message)
                        const loginResponse = await login({
                            grant_type: 'password',
                            username: customTrim(_values.Email),
                            password: _values.Password
                        })

                        if (loginResponse.access_token) {
                            localStorage.setItem("token", loginResponse.access_token)
                            localStorage.setItem("portalExtraInfo", JSON.stringify(loginResponse?.ExtraInfo))
                            localStorage.setItem("dsTokenExpiration", loginResponse?.expires_in?.toString())
                            // setToken(loginResponse.access_token)

                            setTimeout(() => {
                                // navigate("/dashboard/thankyouregister" + location.search)
                                window.location.href = "/#/dashboard/thankyouregister" + location.search
                            }, 1000)
                        }
                    }

                }, (error) => {

                })


            } catch (error) {

            }
        }

    }
    const validate = (values: any) => {
        if (values?.Mobile && values?.Mobile !== "") {
            let mobile = values.Mobile
            if (checkForNumericEnFaString(values.Mobile)) {
                mobile = persianToEnglishChar(values.Mobile)
            }

            if (!/^(?:(\u0660\u0669[\u0660-\u0669][\u0660-\u0669]{8})|(\u06F0\u06F9[\u06F0-\u06F9][\u06F0-\u06F9]{8})|(09[0-9][0-9]{8}))$/.test(mobile)) {
                return { Mobile: "شماره موبایل وارد شده اشتباه است" }

            }
        }
    }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: userInfo,
        onSubmit: handleSubmit,
        validate,
    })

    useEffect(() => {

        if (formik.values?.CareerFieldId === "0") {
            setFormState({ displayOtherCareer: true })
        } else {
            setFormState({ displayOtherCareer: false })

        }

    }, [formik.values?.CareerFieldId])

    return (
        <div className='register-context'>
            <div className='logoHOlder d-flex justify-content-center'>
                <a target='_blank' href='https://daftareshoma.com/'>
                    <img alt='daftareshoma' src={DSLogo} />

                </a>
            </div>
            <div className='row' >
                <div className='container-login col-xs-12 col-sm-12 col-md-8 col-lg-8 '  >
                    <CForm className='frm' onSubmit={formik.handleSubmit} autoComplete="off">
                        <div className='d-flex flex-row justify-content-center loginTitle'>
                            <label> {t('CREATE_ACCOUNT')}
                                <RegisterSVG width={30} height={30} />
                            </label>
                        </div>
                        <hr />
                        <CRow>
                            <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputName" className='d-flex flex-row justify-content-start lbl-frm'>{t('NAME')} <span className='req-spn'>*</span></label>
                                    <input type='text'
                                        name="FirstName"
                                        id='FirstName'
                                        value={formik.values.FirstName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control' />
                                    {formik.errors.FirstName && formik.touched.FirstName && <label className='label-danger '>{formik.errors.FirstName}</label>}
                                </div>
                            </CCol>
                            <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputLastName" className='d-flex flex-row justify-content-start lbl-frm'>{t('LAST_NAME')} <span className='req-spn'>*</span></label>
                                    <input type='text' name="LastName"
                                        value={formik.values.LastName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control' />
                                    {formik.errors.LastName && formik.touched.LastName && <label className='label-danger '>{formik.errors.LastName}</label>}
                                </div>
                            </CCol>

                        </CRow>
                        <CRow className='mt-2'>
                            <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputEmail" className='d-flex flex-row justify-content-start lbl-frm'>{t('EMAIL')}  <span className='req-spn'>*</span></label>



                                    <div className='email-container' >
                                        <input type='text' name="Email" id="exampleInputLastEmail"
                                            placeholder={t('EMAIL') || ""}
                                            value={formik.values.Email}
                                            onChange={(e) => { formik.handleChange(e); dispatch(resetIsExistEmailProps()); }}
                                            onBlur={formik.handleBlur}
                                            className='form-control' />
                                        {getIsEmailExistSuccess && getIsEmailExistResult && isValidEmailStrictly(customTrim(formik.values.Email)) && !customTrim(formik.errors.Email) &&
                                            <span className='sp-success'>
                                                <CheckBoldSVG fill='#1B9E3E' styles={undefined} /></span>}

                                        {getIsEmailExistPending && <span className='sp-pending'><CSpinner size="sm" color="dark" /></span>}
                                    </div>
                                    {(!isValidEmailStrictly(customTrim(formik.values.Email)) && formik.touched.Email && !formik.errors.Email) ? <label className='label-danger '>ایمیل واردشده نامعتبر است </label> :
                                        formik.errors.Email && formik.touched.Email ? <label className='label-danger '>{formik.errors.Email}</label> :
                                            getIsEmailExistSuccess && !getIsEmailExistResult ?
                                                <label className='label-danger is-email-exist-error exist-email' >
                                                    {t('EXIST_EMAIL')}
                                                    <Link to="/login" >ورود به پرتال</Link>
                                                </label > : ""}


                                </div>
                            </CCol>
                            <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputPassword1" className='d-flex flex-row justify-content-start lbl-frm' >{t('PASSWORD')} <span className='req-spn'>*</span></label>


                                    <div className='password-container' >
                                        <input type={formState.displayPassword ? 'password' : 'text'}
                                            name="Password" id="exampleInputPassword1"
                                            placeholder={t('PASSWORD') || ""}
                                            value={formik.values.Password}
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            className='form-control' autoComplete="new-password" />
                                        {formik.errors.Password && formik.touched.Password && <label className='label-danger '>{formik.errors.Password}</label>}

                                        <span onClick={() => setFormState({ displayPassword: !formState.displayPassword })}>
                                            {!formState.displayPassword ? <CloseEyeSVG /> : <EyeSVG />}
                                        </span>
                                    </div>
                                </div>
                            </CCol>

                        </CRow>
                        <CRow className='mt-2'>
                            <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputMobile" className='d-flex flex-row justify-content-start lbl-frm'>{t('MOBILE')}  <span className='req-spn'>*</span></label>

                                    <input type='text' name="Mobile"
                                        value={formik.values.Mobile}
                                        onChange={formik.handleChange}
                                        autoComplete="off"
                                        onBlur={formik.handleBlur}
                                        placeholder={t('MOBILE') || ""}
                                        className='form-control' />
                                    {formik.errors.Mobile && formik.touched.Mobile && <label className='label-danger '>{formik.errors.Mobile}</label>}

                                    {formState.phoneNumberError && !formik.errors.Mobile && <label className='label-danger' >
                                        شماره موبایل وارد شده اشتباه است

                                    </label >}
                                </div>
                            </CCol>
                            <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputGender" className='d-flex flex-row justify-content-start lbl-frm' >{t('GENDER')} <span className='req-spn'>*</span></label>

                                    <select name="Gender"
                                        value={formik.values.Gender}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-select'  >
                                        {(formik.values.Gender !== '1' && formik.values.Gender !== '2') && <option>{t('PLEASE_SELECTION')}</option>}
                                        <option value={'1'}>{t('FEMALE')}</option>
                                        <option value={'2'}>{t('MALE')}</option>

                                    </select>
                                    {formik.errors.Gender && formik.touched.Gender && <label className='label-danger '>{formik.errors.Gender}</label>}
                                </div>
                            </CCol>

                        </CRow>
                        <CRow className='mt-2'>
                            <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputLastCreer" className='d-flex flex-row justify-content-start lbl-frm'>{t('ACTIVATION_FIELD')} <span className='req-spn'>*</span></label>
                                    <select name="CareerFieldId"
                                        className='form-select'
                                        value={formik.values.CareerFieldId}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        {formik.values.CareerFieldId === "" && <option value="">لطفا انتخاب کنید</option>}
                                        {careerList?.map((item: any, idx: number) => <option value={item.Id} key={idx}>{item.Title}</option>)}
                                        <option value="0">سایر...</option>


                                    </select>
                                    {formik.errors.CareerFieldId && formik.touched.CareerFieldId && <label className='label-danger '>{formik.errors.CareerFieldId}</label>}

                                </div>
                            </CCol>
                            {formState.displayOtherCareer && <CCol lg={6} xs={12} >
                                <div className="col-lg-10 col-xs-12 col-md-12 form-group">
                                    <label htmlFor="exampleInputActivationFieldOther" className='d-flex flex-row justify-content-start lbl-frm'>{t('ACTIVATION_FIELD')}
                                        <span className='req-spn'>*</span></label>


                                    <input type='text' id="exampleInputActivationFieldOther"
                                        aria-describedby="activationFieldOtherHelp"
                                        name="OtherCareerField"
                                        placeholder={t('ACTIVATION_FIELD') || ""}
                                        value={formik.values.OtherCareerField}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control' />
                                    {!formik?.values?.OtherCareerField && <label className='label-danger' >
                                        زمینه فعالیت را وارد کنید

                                    </label >}

                                </div>
                            </CCol>}

                        </CRow>



                        <div className='row'>
                            <div className='col-lg-12 col-xs-12 col-md-12 main-register-buttons-container'>
                                <div className='row'>
                                    <div className='col-lg-6 col-xs-12 col-md-12 display-section'>
                                        <Link to="/login" className="btn frm-btn-back col-xs-12 col-sm-12 col-md-12 col-lg-10" >{t('BACK')}</Link>
                                    </div>
                                    <div className='col-lg-6 col-xs-12 col-md-12 display-section'>
                                        <button type="submit" className="btn  frm-btn col-xs-12 col-sm-12 col-md-12 col-lg-10 d-flex align-items-center  justify-content-center"
                                            disabled={loginPending || registerPending}
                                        >{t('CREATE_ACCOUNT')}
                                            {(loginPending || registerPending) && <CSpinner size='sm' color='light' className='mx-2' />}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>



                        <div className='row '>
                            <div className='col-lg-12 col-xs-12 col-md-12  registerQuestionHoder'>
                                <div className="col-lg-12 col-xs-12 col-md-12  registerQuestion">{t('REGISTER_ACCEPT_ROLE')}</div>
                                <a className='roleLink' target='_blank' href='https://daftareshoma.com/terms-and-conditions/' > {t('ROLE_PLATFORM')}</a>
                                <div className="registerQuestion">{t('IS')}</div>
                            </div>
                        </div>


                    </CForm>
                </div>
            </div>

            <div className='row  footerTxt'>
                <div className='col-lg-12 col-xs-12 col-md-12 d-flex flex-row justify-content-center'>
                    <span className='d-flex flex-row justify-content-center col-lg-12 col-xs-12 col-md-12'>
                        {t('FOOTER')}
                    </span>
                </div>
            </div>

        </div>
    )
}

export default RegisterPage